import {RouteObject, redirect} from 'react-router';

import {EIntegrationSettingsTab} from './definitions';

const tabNameHash = {
  [EIntegrationSettingsTab.CALLBACK]: 'CallbackSettings',
  [EIntegrationSettingsTab.API_KEY]: 'ApiKeySettings',
  [EIntegrationSettingsTab.MASTER]: 'MasterSettings',
};

const tabs = Object.values(EIntegrationSettingsTab).map((tab) => {
  const tabName = tabNameHash[tab];

  return {
    path: tab.toLowerCase(),
    lazy: async () => ({
      Component: (await import(`./${tabName}`))[tabName],
    }),
  };
});

const children: RouteObject[] = [
  {
    index: true,
    loader: () => redirect(EIntegrationSettingsTab.MASTER.toLowerCase()),
  },
  ...tabs,
];

export const integrationSettingsRoutes: RouteObject = {
  children,
};
